/**
 * @module ol/MapProperty
 */

/**
 * @enum {string}
 */
export default {
  LAYERGROUP: 'layergroup',
  SIZE: 'size',
  TARGET: 'target',
  VIEW: 'view'
};

//# sourceMappingURL=MapProperty.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/MapProperty.js
// module id = 208
// module chunks = 0